var React = require('react');

function ArrowUpRightFromSquare (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.5 0C10.225 0 10 0.225 10 0.5C10 0.775 10.225 1 10.5 1H14.2937L6.64687 8.64688C6.45312 8.84063 6.45312 9.15937 6.64687 9.35312C6.84062 9.54688 7.15938 9.54688 7.35313 9.35312L15 1.70625V5.5C15 5.775 15.225 6 15.5 6C15.775 6 16 5.775 16 5.5V0.5C16 0.225 15.775 0 15.5 0H10.5ZM2 2C0.896875 2 0 2.89687 0 4V14C0 15.1031 0.896875 16 2 16H12C13.1031 16 14 15.1031 14 14V9.5C14 9.225 13.775 9 13.5 9C13.225 9 13 9.225 13 9.5V14C13 14.5531 12.5531 15 12 15H2C1.44687 15 1 14.5531 1 14V4C1 3.44688 1.44687 3 2 3H6.5C6.775 3 7 2.775 7 2.5C7 2.225 6.775 2 6.5 2H2Z","fill":"#1F1F1F"}));
}

ArrowUpRightFromSquare.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ArrowUpRightFromSquare;

ArrowUpRightFromSquare.default = ArrowUpRightFromSquare;
